import axios from "axios";
import { domain } from "../urls";

const getT = () => {
  return fetch(`${domain}/api/v1/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      user_name: "shopify",
      user_password: "MJy7ayjCe6KVv2IESnn9",
    }),
  })
    .then((res) => res.json())
    .then((res) => res.data.token)
    .catch((error) => {
      console.error("error:", error);
    });
};

// 包装一下 axios，添加 token
export const memberRequest = async (params: any) => {
  const T = await getT();
  const { headers, ...rest } = params;

  if (!T) {
    throw new Error("T is null");
  }

  return axios({
    ...rest,
    headers: {
      ...headers,
      token: T,
    },
  });
};

// 添加高度通信函数
export function sendMessageToParent(params: Record<string, any>) {
  window.parent.postMessage(
    {
      ...params,
    },
    "*"
  );
}
